import React from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { withRouter } from "react-router-dom";

import * as runReducer from "containers/Run/reducer";
import * as oldProjectReducer from "containers/OldProject/reducer";
import * as setupReducer from "containers/Setup/reducer";

import CurrentState from "components/CurrentState/CurrentState";
import CurrentStateMini from "components/CurrentState/CurrentStateMini";

import ModelTileContainer from "containers/Tiles/ModelTile";
import CostsWaterfallContainer from "containers/Costs/CostsWaterfall";
import ProcessLimitContainer from "containers/Costs/ProcessLimit";

class CurrentStateContainer extends React.PureComponent {
  render() {
    const { id, isMini, isHeader, isBlueprint, setup, currentState } = this.props;

    return isMini ? (
      <CurrentStateMini
        {...this.props}
        costs={<CostsWaterfallContainer id={id} isMini isBlueprint={isBlueprint} setup={setup} />}
        tile={<ModelTileContainer model={currentState} />}
        processLimit={<ProcessLimitContainer id={id} setup={setup} isMini />}
      />
    ) : (
      <CurrentState
        {...this.props}
        costs={<CostsWaterfallContainer id={id} isHeader={isHeader} isBlueprint={isBlueprint} setup={setup} />}
        processLimit={isHeader || isBlueprint ? <div /> : <ProcessLimitContainer id={id} setup={setup} />}
        tile={<ModelTileContainer model={currentState} />}
      />
    );
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const id = ownProps.id;

  return {
    initRun: () => {},
    updateStep: (step) => dispatch(oldProjectReducer.updateStep(step)),
    updateTimePeriod: (timePeriod) => dispatch(updateTimePeriod(id, timePeriod))
  };
};

const mapStateToProps = (state, ownProps) => {
  const id = ownProps.id;

  return {
    id: id,
    currentState: runReducer.getTransformedModelById(state, id, "Current State"),
    timePeriod: setupReducer.getTimePeriod(state, id)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(CurrentStateContainer);
